import React from 'react';
import { Router, } from 'react-router-dom';
import { history } from '../request';
import { getBasename } from './homepage';

type Props = {
	children: React.ReactNode;
};

export const basename = getBasename();


export const getCurrentBasename = (): string => {
	return getBasename();
};

const CustomRouter = ({ children }: Props) => {
	const [state, setState] = React.useState({
		action: history.action,
		location: history.location,
	});


	React.useLayoutEffect(() => {
		const unlisten = history.listen((update) => {
			setState(update);
		});

		return unlisten;
	}, []);

	return (
		<Router
			basename={basename}
			location={state.location}
			navigator={history}
			navigationType={state.action}
		>
			{children}
		</Router>
	);
};

export default CustomRouter;
